import { useLocation, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

interface ReferencedPostsNavigationOptions {
  session_id: string;
  block_id: string;
  answer_id: string;
  parts: 'overview';
  part_id: string;
}

export function useReferencedPostsNavigation(options: ReferencedPostsNavigationOptions) {
  const { session_id, block_id, answer_id, parts, part_id } = options;
  const navigate = useNavigate();
  const location = useLocation();
  const { workspaceId } = useWorkspaceId();

  return useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('session_id', session_id);
    searchParams.set('block_id', block_id);
    searchParams.set('answer_id', answer_id);
    searchParams.set('parts', parts);
    searchParams.set('part_id', part_id);
    navigate({
      to: `/workspace/${workspaceId}/insight/referenced-posts`,
      search: {
        ...Object.fromEntries(searchParams),
      },
    });
  }, [answer_id, block_id, location.search, navigate, part_id, parts, session_id, workspaceId]);
}
